import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { trackDatadogAction } from '@proposify/frontend-observability';
import { DEFAULT_PAGE_SIZE, PAGE_SIZES, type PageSize } from '../../shared/gridConfig';
import { pageSizeSelectTestIds } from './PageSizeSelect.test-ids';

interface PageSizeSelectProps {
  value?: PageSize;
  onChange?: (value: PageSize) => void;
}

const PageSizeSelect = ({ value = DEFAULT_PAGE_SIZE, onChange }: PageSizeSelectProps) => {
  const { t } = useTranslation();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selected = PAGE_SIZES.find((size) => size.label === event.target.value) ?? DEFAULT_PAGE_SIZE;
    trackDatadogAction({ action: 'Page Size Changed', data: { pageSize: selected.label } });
    onChange?.(selected);
  };

  return (
    <Box sx={{ width: '100%' }} data-testid={pageSizeSelectTestIds.container}>
      <TextField
        select
        fullWidth
        size="small"
        label={t('document.page.size.label')}
        value={value.label}
        onChange={handleChange}
        data-testid={pageSizeSelectTestIds.select}
        inputProps={{ 'data-dd-action-name': 'Page Size Select' }}
        SelectProps={{
          MenuProps: {
            disableScrollLock: true,
          },
        }}
        sx={{
          '& .MuiInputBase-input': { fontSize: '16px' },
        }}
      >
        {PAGE_SIZES.map((size) => (
          <MenuItem key={size.label} value={size.label} data-dd-action-name={`Page Size Option ${size.label}`}>
            {t(size.label)}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default PageSizeSelect;
